// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"O1-z","button":"P1-z","disabled":"Q1-z","creditCard":"R1-z","wrapper":"S1-z"};